import { bindActionCreators } from 'redux';

import {
  canEditParentFolderSelector,
  editableComponentsListSelector
} from 'app/Can/selectors';
import { checkStatusAndSwitchToComponentThunk } from 'app/ComponentSearch/thunks';
import { clearComponentUsage } from 'app/ComponentUsage/actions';
import { getComponentUsage } from 'app/ComponentUsage/thunks';
import {
  addNewComponentToPageThunk as addNewComponentToPage,
  changePagePropertyDetail,
  editComponentOnPageThunk as editComponentOnPage,
  replaceComponentWithACopyThunk as replaceComponentWithACopy
} from 'app/Explorer/thunks';
import { notifySuccess } from 'app/Notifications/actions';
import { changePageComponentsList } from 'app/Page/actions';
import { resyncFlashEventLP } from 'app/Page/thunks';
import {
  handleComponentSelection,
  handleComponentDeselection,
  handleComponentHoverEnter,
  handleComponentHoverLeave
} from 'app/PreviewPane/actions';

import {
  categoryIdSelector,
  flashEventsCategorySelector,
  flashEventsRunAsOfSelector,
  headlineSelector,
  isCompassPageSelector,
  isPageSelectedSelector,
  nodeSelector,
  pageComponentsSelector,
  pagePayloadSelector,
  pageTemplateNameSelector,
  pageTypeSelector,
  routeMappingSelector,
  seoSettingsSelector
} from 'app/Page/selectors';
import {
  componentSelectedSelector,
  componentHoveringSelector,
  contentLinkDisabledSelector,
  mwpIFrameSelector,
  previewMetadataSelector,
  unsupportedComponentsSelector
} from 'app/PreviewPane/selector';
import { renderingEnvNameSelector } from 'app/RenderingEnvironment/selectors';
import { visitComponent, visitPage } from 'app/Router/actions';
import { clearSearch } from 'app/Search/actions';
import { addFilter } from 'app/Search/thunks';
import isPageFavoriteSelector from 'app/UserInfo/selectors/isPageFavorite';
import { toggleFavoriteContentThunk } from 'app/UserInfo/thunks';
import connect from 'utils/store/connect';

import PageComponentsList from './components/PageComponentsList';

/**
 * map redux state to react component properties
 * @param {object} state - redux state object
 * @returns {object} react props
 */
const mapStateToProps = state => ({
  categoryId: categoryIdSelector(state),
  componentHovering: componentHoveringSelector(state),
  componentSelected: componentSelectedSelector(state),
  componentsList: editableComponentsListSelector(state),
  contentLinkDisabled: contentLinkDisabledSelector(state),
  flashEventPageCategory: flashEventsCategorySelector(state),
  flashEventPageRunAsOf: flashEventsRunAsOfSelector(state),
  headline: headlineSelector(state),
  isCompassPage: isCompassPageSelector(state),
  isFavorite: isPageFavoriteSelector(state, pagePayloadSelector(state).Id),
  isPageSelected: isPageSelectedSelector(state),
  isReadonly: !canEditParentFolderSelector(state),
  mwpIFrameRef: mwpIFrameSelector(state),
  node: nodeSelector(state),
  pagePayload: pagePayloadSelector(state),
  pageTemplateName: pageTemplateNameSelector(state),
  pageType: pageTypeSelector(state),
  renderingEnvName: renderingEnvNameSelector(state),
  routeMapping: routeMappingSelector(state),
  seoSettings: seoSettingsSelector(state),
  pageComponents: pageComponentsSelector(state),
  previewMetadata: previewMetadataSelector(state),
  unsupportedComponentList: unsupportedComponentsSelector(state)
});

/**
 * map action creators to react component properties
 * @param {Function} dispatch - redux dispatch function
 * @returns {object} react props
 */
const mapDispatch = function mapDispatchToProps(dispatch) {
  const bindables = {
    addFilter,
    addNewComponentToPage,
    changePagePropertyDetail,
    checkStatusAndSwitchToComponent: checkStatusAndSwitchToComponentThunk,
    clearComponentUsage,
    clearSearch,
    editComponentOnPage,
    getComponentUsage,
    handleComponentHoverEnter,
    handleComponentHoverLeave,
    handleComponentSelection,
    handleComponentDeselection,
    onListChange: changePageComponentsList,
    notifySuccess,
    replaceComponentWithACopy,
    resyncFlashEventLP,
    toggleFavoriteContent: toggleFavoriteContentThunk
  };
  return {
    ...bindActionCreators(bindables, dispatch),
    unboundVisitComponent: visitComponent,
    unboundVisitPage: visitPage
  };
};

export default connect(mapStateToProps, mapDispatch)(PageComponentsList);
